<template>
  <div class="chat-message">
    <div>
      <span v-if="message.received" class="text-header">From {{ participantName(message.senderId) }} to {{ message.private ? 'you' : 'all' }}</span>
      <span v-else class="text-header">To {{ participantName(message.recipientId) }}</span>
      <span class="time">{{ displayTime(message.time) }}</span>
    </div>
    <p class="text">{{ message.text }}</p>
  </div>
</template>

<script>
const ChatMessage = {
  name: 'ChatMessage',

  props: {
    message: {
      type: Object,
      required: true
    }
  },

  computed: {
    allParticipants() {
      return this.$store.getters['g2wSession/allParticipants'];
    }
  },

  methods: {
    displayTime(time) {
      const locale = this.$store.state.g2wEnv.locale;
      return new Date(time).toLocaleTimeString(locale, {hour: 'numeric', minute: 'numeric'});
    },

    participantName(participantId) {
      const participant = this.allParticipants[participantId];
      if (participant) {
        return participant.name;
      }

      return participantId;
    }
  }
};
export default ChatMessage;
</script>

<style lang="sass">
  .chat-message
    .time
      font-size: .85em
      color: grey
      padding-left: 5px

    .text-header
      font-weight: bold

    .text
      margin: 0
</style>
